function ContentTypeFormatterFactory($translate) {
      // ContentTypeFormatter converts MIME type to a human readable content type e.g. 'application/pdf' -> 'PDF Document'
      // Supports 7 classes of formats mentioned in the GorillaBoy FAQv19question34 - word, powerpoint, excel, pdf, webpage, text, image
      // For all other types it returns the string 'File' to be rendered

    var contentTypeInfoMap = {
        "application/pdf": {
            name: $translate.instant("FILE_TYPES.PDF"),
            category: $translate.instant("FILE_TYPES.PDF")
        },
        "application/javascript": {
            name: $translate.instant("FILE_TYPES.JS"),
            category: $translate.instant("FILE_TYPES.JS")
        },
        "application/vnd.ms-excel": {
            name: $translate.instant("FILE_TYPES.MICROSOFT_EXCEL"),
            category: $translate.instant("FILE_TYPES.EXCEL")
        },
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
            name: $translate.instant("FILE_TYPES.MICROSOFT_EXCEL"),
            category: $translate.instant("FILE_TYPES.EXCEL")
        },
        "text/csv": {
            name: $translate.instant("FILE_TYPES.COMMA_SEPARATED_VALUES"),
            category: $translate.instant("FILE_TYPES.CSV")
        },
        "application/vnd.ms-powerpoint": {
            name: $translate.instant("FILE_TYPES.MICROSOFT_POWERPOINT"),
            category: $translate.instant("FILE_TYPES.POWERPOINT")
        },
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
            name: $translate.instant("FILE_TYPES.MICROSOFT_POWERPOINT"),
            category: $translate.instant("FILE_TYPES.POWERPOINT")
        },
        "application/msword": {
            name: $translate.instant("FILE_TYPES.MICROSOFT_WORD"),
            category: $translate.instant("FILE_TYPES.WORD")
        },
        "application/vnd.ms-word": {
            name: $translate.instant("FILE_TYPES.MICROSOFT_WORD"),
            category: $translate.instant("FILE_TYPES.WORD")
        },
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
            name: $translate.instant("FILE_TYPES.MICROSOFT_WORD"),
            category: $translate.instant("FILE_TYPES.WORD")
        },
        "image/gif": {
            name: $translate.instant("FILE_TYPES.GIF_IMAGE"),
            category: $translate.instant("FILE_TYPES.IMAGE")
        },
        "image/jpeg": {
            name: $translate.instant("FILE_TYPES.JPEG_IMAGE"),
            category: $translate.instant("FILE_TYPES.IMAGE")
        },
        "image/png": {
            name: $translate.instant("FILE_TYPES.PNG_IMAGE"),
            category: $translate.instant("FILE_TYPES.IMAGE")
        },
        "image/tiff": {
            name: $translate.instant("FILE_TYPES.TIFF_IMAGE"),
            category: $translate.instant("FILE_TYPES.IMAGE")
        },
        "image/bmp": {
            name: $translate.instant("FILE_TYPES.BMP_IMAGE"),
            category: $translate.instant("FILE_TYPES.IMAGE")
        },
        "text/html": {
            name: $translate.instant("FILE_TYPES.HTML"),
            category: $translate.instant("FILE_TYPES.TEXT")
        },
        "text/plain": {
            name: $translate.instant("FILE_TYPES.TEXT"),
            category: $translate.instant("FILE_TYPES.TEXT")
        }
    };

      var officeContentTypeInfoMap = {
        "application/vnd.ms-excel": "Excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.template": "Excel",
        "application/vnd.ms-excel.sheet.macroenabled.12": "Excel",
        "application/vnd.ms-excel.template.macroenabled.12": "Excel",
        "application/vnd.ms-excel.addin.macroenabled.12": "Excel",
        "application/vnd.ms-excel.sheet.binary.macroenabled.12": "Excel",
        // powerpoint file mime types
        "application/vnd.ms-powerpoint": "Powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": "Powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.template": "Powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.slideshow": "Powerpoint",
        "application/vnd.ms-powerpoint.addin.macroenabled.12": "Powerpoint",
        "application/vnd.ms-powerpoint.presentation.macroenabled.12": "Powerpoint",
        "application/vnd.ms-powerpoint.template.macroenabled.12": "Powerpoint",
        "application/vnd.ms-powerpoint.slideshow.macroenabled.12": "Powerpoint",
        // Word file Mime types
        "application/vnd.openxmlformats-officedocument.wordprocessingml.template" : "Word",
        "application/msword": "Word",
        "application/vnd.ms-word": "Word",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
        "application/vnd.ms-word.document.macroEnabled.12" : "Word",
        "application/vnd.ms-word.template.macroEnabled.12" : "Word"
        
        //Removed One Note and Viso content types as we don't want to support their editing in O365
    };

    var audioPlayableFileContentTypeInfoMap = {
        // pdf file Mime types
        "application/pdf": "Pdf",
        // text file Mime types
        "text/plain": "Text",

        // Word file Mime types
        "application/vnd.openxmlformats-officedocument.wordprocessingml.template" : "Word",
        "application/msword": "Word",
        "application/vnd.ms-word": "Word",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
        "application/vnd.ms-word.document.macroEnabled.12" : "Word",
        "application/vnd.ms-word.template.macroEnabled.12" : "Word"
        
    };

    var officeLegacyContentInfoMap = {
        "application/vnd.ms-excel": "Excel",
        "application/vnd.ms-powerpoint": "Powerpoint",
		"application/msword": "Word",
		"application/vnd.ms-excel.sheet.macroenabled.12": "Excel" // xlsm file
    };

    var onlineEditableFileFormatMap = {
        "application/msword": "Word",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.template": "Word",
        "text/csv": "Excel",
        "application/vnd.ms-excel": "Excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel",
        "application/vnd.ms-powerpoint": "Powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": "Powerpoint"
    };

    var imageMimeTypes = ["image/jpeg", "image/gif", "image/png", "image/tiff", "image/bmp"];

    var unsupportedMimeType = $translate.instant("FILE_TYPES.FILE"),
        otherContentTypeCategory = $translate.instant("FILE_TYPES.OTHER");

    var contentTypeFormatter = {};
    contentTypeFormatter.toReadableString = function (mimeType) {
        var contentTypeInfo = contentTypeInfoMap[mimeType];
        return contentTypeInfo ? contentTypeInfo.name : unsupportedMimeType;
    };

    contentTypeFormatter.getTypeCategory = function (mimeType) {
        if (!mimeType) {
            return otherContentTypeCategory;
        }
        var contentTypeInfo = contentTypeInfoMap[mimeType.toLowerCase()];
        return contentTypeInfo ? contentTypeInfo.category : otherContentTypeCategory;
    };

    contentTypeFormatter.isOfficeFile = function(mimeType) {
        if (!mimeType) {
            return false;
        }
        var contentTypeInfo = officeContentTypeInfoMap[mimeType.toLowerCase()];
        return contentTypeInfo ? true : false;
    };

    contentTypeFormatter.isAudioPlayableFile = function(mimeType) {
        if (!mimeType) {
            return false;
        }
        var contentTypeInfo = audioPlayableFileContentTypeInfoMap[mimeType.toLowerCase()];

        return contentTypeInfo ? true : false;
    };

    contentTypeFormatter.isOnlineEditableFileFormat = function(mimeType) {
        if (!mimeType) {
            return false;
        }
        var contentTypeInfo = onlineEditableFileFormatMap[mimeType.toLowerCase()];
        return contentTypeInfo ? true : false;
    };

    contentTypeFormatter.isPresentationFileFormat = function(mimeType) {
        if (!mimeType) {
            return false;
        }
        var contentTypeInfo = onlineEditableFileFormatMap[mimeType.toLowerCase()];
        return contentTypeInfo === 'Powerpoint' ? true : false;
    };

    contentTypeFormatter.isSpreadsheetFileFormat = function(mimeType) {
        if (!mimeType) {
            return false;
        }
        var contentTypeInfo = onlineEditableFileFormatMap[mimeType.toLowerCase()];
        return contentTypeInfo === 'Excel' ? true : false;
    };

    contentTypeFormatter.isWordFileFormat = function(mimeType) {
        if (!mimeType) {
            return false;
        }
        var contentTypeInfo = onlineEditableFileFormatMap[mimeType.toLowerCase()];
        return contentTypeInfo === 'Word' ? true : false;
    };

    contentTypeFormatter.isOfficeLegacyFile = function(mimeType){
        if (!mimeType) {
            return false;
        }
        var contentTypeInfo = officeLegacyContentInfoMap[mimeType.toLowerCase()];
        return contentTypeInfo ? true : false;
    };

    contentTypeFormatter.isTextFile = function(mimeType) {
        return mimeType === 'text/plain' ? true : false;
    };

    contentTypeFormatter.isPDFFile = function(mimeType) {
        return mimeType === 'application/pdf' ? true : false;
    };

    contentTypeFormatter.isImageFile = function(mimeType) {
        if (!mimeType) {
            return false;
        }
        return imageMimeTypes.indexOf(mimeType.toLowerCase()) !== -1;
    };

    return contentTypeFormatter;
}

angular.module('GorillaBoy.services')
.factory('ContentTypeFormatter', ['$translate', ContentTypeFormatterFactory]);

module.exports = ContentTypeFormatterFactory;
